<template>
  <div class="app-container">
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="listQuery.username" placeholder="请输入账号" style="width: 200px;" clearable @clear="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.parent_username" placeholder="请输入上级账号" style="width: 200px;" clearable @clear="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-input v-model="listQuery.search" placeholder="请输入单位名称" style="width: 200px;" clearable @clear="SearchData" @keyup.enter.native="SearchData" />
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="listQuery.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            @clear="SearchData"
            @keyup.enter.native="SearchData"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>

        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <!-- 弹窗层编辑 -->
      <el-button class="action-item" type="primary" icon="el-icon-plus" @click="HandleCreate">新增</el-button>
      <!-- <el-button class="action-item" type="success" icon="el-icon-edit" @click="BatchUpdate">修改</el-button> -->
      <!-- <el-button class="action-item" type="danger" icon="el-icon-delete" @click="BatchDelete">删除</el-button> -->
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :show-summary="showSummary"
      :summary-method="getSummaries"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
      @selection-change="handleSelectionChange"
    >
      <!--列开始-->
      <el-table-column align="center" type="selection"></el-table-column>
      <el-table-column align="center" type="index" width="50" label="序号 "></el-table-column>
      <el-table-column align="center" prop="company_name" label="单位名称 " show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="company_code" label="统一社会信用代码 " show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="username" label="账号名称 " width="180" show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="passtext" label="初始密码 " width="180" show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="can_num" label="可调用次数 " width="100"> </el-table-column>
      <el-table-column align="center" prop="check_num" label="已调用次数 " width="100"> </el-table-column>
      <el-table-column align="center" prop="remain_num" label="剩余次数 " width="100"> </el-table-column>
      <el-table-column align="center" prop="is_child" label="是否为子额度 " width="130">
        <template slot-scope="scope">
          <span v-if="scope.row.is_child == 1">是</span>
          <span v-if="scope.row.is_child == 2">否</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="parent_name" label="上级额度单位名称 " width="180" show-overflow-tooltip> </el-table-column>
      <el-table-column align="center" prop="destroy_time" label="数据自动销毁时间 " width="160"> </el-table-column>

      <el-table-column align="center" prop="" label="操作" width="300" class-name="action">
        <template slot-scope="scopes">
          <el-button v-if="scopes.row.role_id != 1" size="mini" type="success" plain icon="el-icon-edit" @click="HandleUpdate(scopes.row)">修改</el-button>
          <el-button size="mini" type="primary" plain icon="el-icon-setting" @click="HandleNumSet(scopes.row)">次数设置</el-button>
          <!-- <el-button v-if="scopes.row.role_id == 1" size="mini" type="primary" plain icon="el-icon-setting" @click="HandleAlNumSet(scopes.row)">阿里次数设置</el-button> -->
          <!-- <el-button style="color:#F56C6C;" icon="el-icon-delete" type="text" size="mini" @click="RowDelete(scopes.row)">删除</el-button> -->
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible" width="800px">
      <el-form v-if="dialogFormVisible" ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="150px" style="width: 93%;">
        <el-form-item label="单位名称 " prop="company_name">
          <el-input v-model="temp.company_name" placeholder="请输入单位名称" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="统一社会信用代码 " prop="company_code">
          <el-input v-model="temp.company_code" placeholder="请输入统一社会信用代码" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="账号名称 " prop="username">
          <el-input v-model="temp.username" placeholder="请输入账号名称" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="初始密码 " prop="passtext">
          <el-input v-model="temp.passtext" placeholder="请输入初始密码" maxlength="18" show-word-limit />
        </el-form-item>
        <el-form-item v-if="dialogStatus=='create'" label="可调用次数 " prop="can_num">
          <el-input-number v-model="temp.can_num" :min="0" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="是否为子额度 " prop="is_child">
          <el-radio-group v-model="temp.is_child">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="上级额度单位名称 " prop="parent_name">
          <el-input v-model="temp.parent_name" placeholder="请输入账号名称" maxlength="20" show-word-limit />
        </el-form-item>
        <el-form-item label="数据自动销毁时间 " prop="destroy_time">
          <el-date-picker v-model="temp.destroy_time" value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
    <!--次数设置窗体-->
    <el-dialog title="次数设置" :visible.sync="dialogNumVisible" width="600px">
      <el-form v-if="dialogNumVisible" ref="dataForm" :mode="info" label-position="right" label-width="150px" style="width: 93%;">
        <el-form-item label="单位名称 ">{{ info.company_name }}</el-form-item>
        <el-form-item label="可调用次数 ">{{ info.can_num }}</el-form-item>
        <el-form-item label="剩余次数 ">{{ info.remain_num }}</el-form-item>
        <el-form-item label="增加/减少次数 ">
          <el-input-number v-model="info.num" :controls="false"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogNumVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmNumData">保存</el-button>
      </div>
    </el-dialog>
    <!--阿里次数设置窗体-->
    <!-- <el-dialog title="阿里次数设置" :visible.sync="dialogAlNumVisible" width="600px">
      <el-form v-if="dialogAlNumVisible" ref="dataForm" :mode="info" label-position="right" label-width="150px" style="width: 93%;">
        <el-form-item label="单位名称 ">{{ info.company_name }}</el-form-item>
        <el-form-item label="可调用次数 ">{{ info.al_can_num }}</el-form-item>
        <el-form-item label="剩余次数 ">{{ info.al_remain_num }}</el-form-item>
        <el-form-item label="增加/减少次数 ">
          <el-input-number v-model="info.al_num" :controls="false"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAlNumVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmAlNumData">保存</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import api from '@/api/account' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
import dict_data from '@/api/system/dict_data'
export default {
  name: 'Manage',
  components: { Pagination },
  // 列绑定格式化器
  filters: {
  },
  mixins: [commonList],
  data() {
    return {
      api,
      rules: {
        company_name: [{ required: true, message: '请输入单位名称', trigger: ['blur', 'change'] }],
        company_code: [{ required: true, message: '请输入统一社会信用代码', trigger: ['blur', 'change'] }],
        username: [{ required: true, message: '请输入账号名称', trigger: ['blur', 'change'] }],
        passtext: [{ required: true, message: '请输入初始密码', trigger: ['blur', 'change'] }],
        can_num: [{ required: true, message: '请输入可调用次数', trigger: ['blur', 'change'] }],
        is_child: [{ required: true, message: '请选择是否为子额度', trigger: ['blur', 'change'] }]
        // parent_name: [{ required: true, message: '请输入上级额度单位名称', trigger: ['blur', 'change'] }],
        // destroy_time: [{ required: true, message: '请选择数据自动销毁时间', trigger: ['blur', 'change'] }]
      },
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: 'asc', // 默认排序方式,
        sort: 'order_no',
        group_id: this.$route.query.group_id
      },
      dialogImportVisible: false,
      import_file: {
        file: '',
        name: ''
      },
      lock: false,
      selectIds: [],
      dialogNumVisible: false,
      dialogAlNumVisible: false,
      info: {},
      showSummary: false,
      // 字典参数
      dictionary: []
      // 字典参数
    }
  },
  created() {
    this.loadData()
    dict_data.Drop({ sort: 'sort', order: 'asc', isPaginator: false, dict_code: '' }).then(response => {
      this.dictionary = response.data
    })
  },
  methods: {
    // 加载数据表
    loadData() {
      this.listLoading = true
      this.api.Query(this.listQuery).then(response => {
        this.list = response.data.items
        this.total = response.data.total
        if (this.total > 1 && this.listQuery.parent_username) {
          this.showSummary = true
        } else {
          this.showSummary = false
        }
        this.listLoading = false
      })
    },
    getSummaries(param) {
      const fields = ['can_num', 'check_num', 'remain_num']
      const { columns, data } = param
      const sums = []
      console.log(columns, data, '------------------------------------------')

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (fields.indexOf(column.property) > -1) {
          const values = data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          } else {
            sums[index] = ''
          }
        } else {
          sums[index] = ''
        }
      })

      return sums
    },
    ConfirmNumData() {
      if (this.info.num === 0 || this.info.num === '') {
        this.$message({ message: '请输入增加/减少次数', type: 'warning' })
        return
      }
      if (this.info.num < 0) {
        if (Math.abs(this.info.num) > this.info.remain_num) {
          this.$message({ message: '减少次数不得大于剩余次数', type: 'warning' })
          return
        }
      }

      api.SetNums({
        id: this.info.id,
        num: this.info.num
      }).then(res => {
        this.dialogNumVisible = false
        this.$store.dispatch('user/getInfo')
        this.loadData()
        this.$message({ message: '次数设置成功', type: 'success' })
      })
    },
    ConfirmAlNumData() {
      if (this.info.al_num === 0 || this.info.al_num === '') {
        this.$message({ message: '请输入增加/减少次数', type: 'warning' })
        return
      }
      if (this.info.num < 0) {
        if (Math.abs(this.info.al_num) > this.info.al_remain_num) {
          this.$message({ message: '减少次数不得大于剩余次数', type: 'warning' })
          return
        }
      }
      api.SetAlNums({
        id: this.info.id,
        num: this.info.al_num
      }).then(res => {
        this.dialogAlNumVisible = false
        this.$store.dispatch('user/getInfo')
        this.loadData()
        this.$message({ message: '阿里次数设置成功', type: 'success' })
      })
    },
    HandleNumSet(row) {
      this.info = row
      this.info.num = 0
      this.dialogNumVisible = true
    },
    HandleAlNumSet(row) {
      this.info = row
      this.info.num = 0
      this.dialogAlNumVisible = true
    },
    ConfirmData() {
      this.afterAddAttribute && this.afterAddAttribute()
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          const loadingObj = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            target: document.querySelector('.submit-test-dialog')
          })
          this.api
            .Create(this.temp)
            .then(response => {
              this.$store.dispatch('user/getInfo')
              this.dialogFormVisible = false
              this.SearchData()
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
            })
            .finally(() => {
              loadingObj.close()
            })
        }
      })
    },
    ConfirmExportData() {
      const params = []
      if (this.selectIds.length > 0) {
        params.push('ids=' + this.selectIds.join(','))
      } else {
        params.push('group_id=' + this.listQuery.group_id)
        if (this.listQuery.waybill_number) {
          params.push('waybill_number=' + this.listQuery.waybill_number)
        }
        if (this.listQuery.time) {
          params.push('time=' + this.listQuery.time)
        }
        if (this.listQuery.result) {
          params.push('result=' + this.listQuery.result)
        }
      }
      location.href = process.env.VUE_APP_BASE_API + 'admin/user/exportExcel?' + params.join('&')
      // window.open(process.env.VUE_APP_BASE_API + 'admin/user/exportExcel?' + params.join('&'))
    },
    handleSelectionChange(val) {
      this.selectIds = val.map(i => i.id)
    },
    resetTemp() {
      const date = new Date()
      date.valueFormat = 'yyyy-MM-dd HH:mm:ss'
      this.temp = {
        id: undefined,
        bill_number: '',
        waybill_number: '',
        name: '',
        idcard: '',
        status: 1,
        create_time: date
      }
    }

  }
}
</script>
<style>
.el-form-item__label{
  padding:0 20px 0 0
}
</style>
